import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import TitleComponent from "../../components/TitleComponent";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import pl from "date-fns/locale/pl";
import enGB from "date-fns/locale/en-GB";
import WelcomePdf from "../../components/WelcomePdf";
import FlightPdf from "../../components/FlightPdf";
import { pdf } from "@react-pdf/renderer";
import api from "../../api";
import produce from "immer";
import Loader from "../../components/LoaderComponent";
import { calculatePdfData } from "../../lib/printerHelper";
import { handleApiError } from "../../lib/helper";
import isEmpty from "lodash.isempty";
import { notify } from "react-notify-toast";
import { saveAs } from "file-saver";
import useTranslation from "../../i18n/useTranslation";
import { DATEPICKER_DATE_FORMAT } from "../../i18n/dates";

function Prints(props) {
   const { t, locale } = useTranslation();
   const datePickerLocales = { pl, en: enGB };
   const availablePdf = [
      { value: "flight", label: t("prints.types.flight") },
      { value: "welcome", label: t("prints.types.welcome") },
      { value: "welcomeEnvelope", label: t("prints.types.welcomeEnvelope") }
   ];

   const availableThemes = [
      { value: "color", label: t("prints.themes.color") },
      { value: "b&w", label: t("prints.themes.blackAndWhite") }
   ];

   const availableEnvelopeFormats = [
      { value: "A4", label: "A4" },
      { value: "A5", label: "A5" }
   ];

   const initialFormData = {
      hotel: {},
      date: "",
      resident: {},
      emergencyNumber: "",
      selectedTransfers: []
   };

   const [pdfType, setPdfType] = useState("");
   const [initDate, setInitDate] = useState(moment().format("YYYY-MM-DD"));
   const [selectedProductKey, setSelectedProductKey] = useState(props.session.selectedProductKey);
   const [hotels, setHotels] = useState([]);
   const [formData, setFormData] = useState(initialFormData);
   const [productKeys, setProductKeys] = useState([]);
   const [fetching, setFetching] = useState(true);
   const [hotelsData, setHotelsData] = useState([]);
   const [generatedPdfData, setGeneratedPdfData] = useState({});
   const [theme, setTheme] = useState(availableThemes[0].value);
   const [envelopeFormat, setEnvelopeFormat] = useState(availableEnvelopeFormats[0].value);

   useEffect(() => {
      setFetching(true);
      api.getPrintHotels(selectedProductKey.value, initDate)
         .then((resp) => {
            setHotelsData(resp.data);
            const hotelSelect = resp.data
               .map((hotel) => ({ value: hotel.hotelId, label: hotel.nazwaHotelu }))
               .sort((a, b) => a.label.localeCompare(b.label));
            setHotels(hotelSelect);
         })
         .finally(() => setFetching(false));
      //eslint-disable-next-line
   }, []);

   useEffect(() => {
      const keys = props.session.kodyProduktow.map((option) => ({ value: option, label: option }));
      setProductKeys(keys);
   }, [props.session.kodyProduktow]);

   useEffect(() => {
      setFormData(initialFormData);
      setGeneratedPdfData({});
      //eslint-disable-next-line
   }, [pdfType]);

   useEffect(() => {
      if (isEmpty(formData.hotel)) return;
      const selectedHotel = hotelsData.find((hotel) => hotel.hotelId === formData.hotel.value);
      const direction = pdfType === "welcome" ? selectedHotel.przylot : selectedHotel.wylot;
      const resetTransfers = produce(formData, (draft) => {
         draft.selectedTransfers = direction.trasyWCIDs;
         draft.date = direction.data;
         draft.emergencyNumber = "";
         draft.resident = {};
      });
      setFormData(resetTransfers);
      setGeneratedPdfData({});
      //eslint-disable-next-line
   }, [formData.hotel]);

   useEffect(() => {
      if (isEmpty(formData.hotel) || isEmpty(formData.date.toString())) return;
      if (pdfType === "welcomeEnvelope") return;
      fetchFormData(pdfType);
      //eslint-disable-next-line
   }, [formData.hotel, formData.date]);

   useEffect(() => {
      setFetching(true);
      api.getPrintHotels(selectedProductKey.value, initDate)
         .then((resp) => {
            setHotelsData(resp.data);
            const hotelSelect = resp.data
               .map((hotel) => ({ value: hotel.hotelId, label: hotel.nazwaHotelu }))
               .sort((a, b) => a.label.localeCompare(b.label));
            setHotels(hotelSelect);
         })
         .finally(() => setFetching(false));
      setFormData(initialFormData);
      setGeneratedPdfData({});
      //eslint-disable-next-line
   }, [selectedProductKey, initDate]);

   const changeData = (field, value) => {
      const produceData = produce(formData, (draft) => {
         draft[field] = value;
      });
      setFormData(produceData);
   };

   const changeGeneratedPdf = (field, value) => {
      const produceData = produce(generatedPdfData, (draft) => {
         draft[field] = value;
      });
      setGeneratedPdfData(produceData);
   };

   const fetchFormData = () => {
      const data = {
         kodProduktu: selectedProductKey.value,
         hotelId: formData.hotel.value,
         wybranaTrasa: {
            trasyWCIDs: formData.selectedTransfers,
            data: moment(formData.date).format("YYYY-MM-DD")
         }
      };
      setFetching(true);
      switch (pdfType) {
         case "welcome":
            return api
               .initWelcomePdf(data)
               .then((resp) => setGeneratedPdfData(resp.data))
               .catch((err) => {
                  if (isEmpty(err.response.data.errors)) return;
                  err.response.data.errors.forEach((error) => notify.show(error, "warning", 3000));
               })
               .finally(() => setFetching(false));
         case "flight":
            return api
               .initFlightPdf(data)
               .then((resp) => setGeneratedPdfData(resp.data))
               .catch((err) => {
                  if (isEmpty(err.response.data.errors)) return;
                  err.response.data.errors.forEach((error) => notify.show(error, "warning", 3000));
               })
               .finally(() => setFetching(false));
         default:
            return;
      }
   };

   const renderForm = () => {
      if (isEmpty(formData.hotel) || isEmpty(pdfType)) return;
      switch (pdfType) {
         case "flight":
            return (
               <div className="row">
                  <div className="col-12">
                     <textarea
                        className="width--100 select-textarea"
                        onChange={(ev) => changeGeneratedPdf("zapisaneUwagi", ev.target.value)}
                        value={generatedPdfData.zapisaneUwagi}
                        rows="4"
                        placeholder={t("prints.placeholders.topNotes")}
                     />
                  </div>
                  <div className="col-12">
                     <textarea
                        className="width--100 select-textarea margin--top"
                        onChange={(ev) => changeGeneratedPdf("zapisaneInformacje", ev.target.value)}
                        value={generatedPdfData.zapisaneInformacje}
                        rows="4"
                        placeholder={t("prints.placeholders.bottomNotes")}
                     />
                  </div>
               </div>
            );
         case "welcome": {
            let residents = [];
            if (!isEmpty(generatedPdfData) && generatedPdfData.rezydenci) {
               residents = generatedPdfData.rezydenci.map((resident) => ({
                  value: resident.id,
                  label: resident.imieNazwisko,
                  phoneNumber: resident.telefon
               }));
            }
            return (
               <React.Fragment>
                  <div className="row">
                     <div className="col-6">
                        <Select
                           placeholder={t("prints.placeholders.resident")}
                           value={
                              !isEmpty(formData.resident) &&
                              residents.find((option) => option.id === formData.resident.value)
                           }
                           options={residents}
                           onChange={(option) => {
                              const produceData = produce(formData, (draft) => {
                                 draft.resident = option;
                                 draft.emergencyNumber = option.phoneNumber;
                              });
                              setFormData(produceData);
                           }}
                           clearable={false}
                        />
                     </div>
                     <div className="col-6">
                        <input
                           className="width--100 select-input"
                           value={formData.emergencyNumber}
                           onChange={(ev) => changeData("emergencyNumber", ev.target.value)}
                           placeholder={t("prints.placeholders.emergencyNumber")}
                        />
                     </div>
                  </div>
                  <div className="row margin--top">
                     <div className="col-12">
                        <textarea
                           className="width--100 select-textarea"
                           onChange={(ev) => changeGeneratedPdf("informacje", ev.target.value)}
                           value={generatedPdfData.informacje}
                           rows="4"
                           placeholder={t("prints.placeholders.welcomeInfo")}
                        />
                     </div>
                     <div className="col-12">
                        <textarea
                           className="width--100 select-textarea margin--top"
                           onChange={(ev) => changeGeneratedPdf("uwagi", ev.target.value)}
                           value={generatedPdfData.uwagi}
                           rows="4"
                           placeholder={t("prints.placeholders.meetingsComment")}
                        />
                     </div>
                  </div>
               </React.Fragment>
            );
         }
         case "welcomeEnvelope":
            return null;
         default:
            return;
      }
   };

   const lastPrintedNotify = () => {
      if (isEmpty(generatedPdfData.dataOstatniegoWydruku)) return;
      return (
         <div key="notify" className="warning margin--bottom">
            <div className="warning--label">{t("common.warning")}</div>
            <div className="flex width--100 flex--space-between">
               <div>
                  {t("prints.lastGeneratedPrefix")}{" "}
                  <span className="text-bold">{generatedPdfData.dataOstatniegoWydruku}</span>
                  {t("prints.lastGeneratedSuffix")}
               </div>
            </div>
         </div>
      );
   };

   const generateWelcomeEnvelopePdf = async () => {
      setFetching(true);
      try {
         const response = await api.initWelcomeEnvelopePdf({
            format: envelopeFormat,
            kodProduktu: selectedProductKey.value,
            hotelID: formData.hotel.value,
            data: initDate
         });
         const filename = `koperta_powitalna_${envelopeFormat}_${initDate}`;
         saveAs(response.data, `${filename}.pdf`);
      } catch (error) {
         await handleApiError(error, "downloadWelcomeEnvelopePdfError");
         return;
      } finally {
         setFetching(false);
      }
   };

   const generatePdf = async () => {
      if (isEmpty(pdfType)) return notify.show(t("prints.errors.noPrintType"), "warning", 3000);
      if (isEmpty(formData.hotel)) return notify.show(t("prints.errors.noHotel"), "warning", 3000);

      if (pdfType === "welcomeEnvelope") {
         await generateWelcomeEnvelopePdf();
         return;
      }
      
      const requestData = {
         kodProduktu: selectedProductKey.value,
         hotel: {
            id: formData.hotel.value,
            nazwa: formData.hotel.label
         },
         typWydruku: null,
         data: formData.date,
         uwagi: generatedPdfData.zapisaneUwagi || generatedPdfData.uwagi,
         informacje: generatedPdfData.zapisaneInformacje || generatedPdfData.informacje
      };
      let pdfDocument, filename;
      if (pdfType === "flight") {
         if (isEmpty(generatedPdfData.tabela))
            return notify.show(
               t("prints.errors.noTransfers"),
               "warning",
               3000
            );
         pdfDocument = (
            <FlightPdf
               isScaffold
               topComment={generatedPdfData.zapisaneUwagi}
               bottomComment={generatedPdfData.zapisaneInformacje}
               header={generatedPdfData.naglowek}
               data={calculatePdfData("flight", generatedPdfData)}
               theme={theme}
            />
         );
         filename = "wylot_" + moment().format("DD_MM_YYYY_HH_mm");
         requestData.typWydruku = 2;
      } else {
         if (isEmpty(formData.resident))
            return notify.show(t("prints.errors.noResident"), "warning", 3000);
         if (
            (isEmpty(generatedPdfData.dyzury) && isEmpty(generatedPdfData.dyzuryTelefoniczne)) ||
            isEmpty(generatedPdfData.spotkanieInformacyjne)
         )
            return notify.show(
               t("prints.errors.noTransfers"),
               "warning",
               3000
            );
         pdfDocument = (
            <WelcomePdf
               isScaffold
               emergencyNumber={formData.emergencyNumber}
               residentName={formData.resident.label}
               hotel={formData.hotel.label}
               welcomeText={generatedPdfData.informacje}
               data={calculatePdfData("welcome", generatedPdfData)}
               theme={theme}
            />
         );
         filename = "serdecznie_witamy_" + moment().format("DD_MM_YYYY_HH_mm");
         requestData.typWydruku = 1;
      }
      api.savePrint(requestData);
      const blob = await pdf(pdfDocument).toBlob();
      saveAs(blob, `${filename}.pdf`);
   };

   const getSecondarySelectValue = () => {
      if (pdfType === "welcomeEnvelope") {
         return availableEnvelopeFormats.find((option) => option.value === envelopeFormat);
      }
      return availableThemes.find((option) => option.value === theme);
   };

   const getSecondarySelectOptions = () => {
      if (pdfType === "welcomeEnvelope") return availableEnvelopeFormats;
      return availableThemes;
   };

   const handleSecondarySelectChange = (option) => {
      if (pdfType === "welcomeEnvelope") {
         setEnvelopeFormat(option.value);
         return;
      }
      setTheme(option.value);
   };

   return (
      <div className="hotels__slide">
         <div
            id="print-scaffold"
            style={{
               position: "absolute",
               width: "180mm",
               top: 0,
               left: 0,
               opacity: 0,
               zIndex: -1,
               fontSize: 15
            }}
         />
         <Loader show={fetching} />
         <TitleComponent className="section_title--width-unset">
            {t("prints.title")}
         </TitleComponent>
         <div className="container_desktop margin--top">
            <div className="row">
               <div className="col-6">
                  <Select
                     placeholder={t("prints.placeholders.selectDestination")}
                     value={selectedProductKey}
                     options={productKeys}
                     onChange={(option) => {
                        setSelectedProductKey(option);
                     }}
                     isClearable={false}
                  />
               </div>
               <div className="col-6">
                  <DatePicker
                     selected={Date.parse(initDate)}
                     onChange={(date) => setInitDate(moment(date).format("YYYY-MM-DD"))}
                     locale={datePickerLocales[locale] || pl}
                     className="select-input width--100"
                     dateFormat={DATEPICKER_DATE_FORMAT}
                     placeholderText={t("prints.placeholders.date")}
                  />
               </div>
            </div>
            <div className="row margin--top margin--bottom">
               <div className="col-6">
                  <Select
                     placeholder={t("prints.placeholders.selectPdf")}
                     value={availablePdf.find((option) => option.value === pdfType)}
                     options={availablePdf}
                     onChange={(option) => {
                        setPdfType(option.value);
                     }}
                     isClearable={false}
                  />
               </div>
               <div className="col-6">
                  <Select
                     placeholder={
                        pdfType === "welcomeEnvelope"
                           ? t("prints.placeholders.selectFormat")
                           : t("prints.placeholders.selectType")
                     }
                     value={getSecondarySelectValue()}
                     options={getSecondarySelectOptions()}
                     onChange={handleSecondarySelectChange}
                     isClearable={false}
                  />
               </div>
            </div>
            <div
               className="row margin--top margin--bottom"
               style={{ display: isEmpty(pdfType) && "none" }}
            >
               <div className="col-12">
                  <Select
                     placeholder={t("prints.placeholders.selectHotel")}
                     value={
                        formData.hotel.value
                           ? hotels.find((hotel) => hotel.value === formData.hotel.value)
                           : null
                     }
                     options={hotels}
                     onChange={(option) => changeData("hotel", option)}
                     isClearable={false}
                  />
               </div>
            </div>
            {lastPrintedNotify()}
            {renderForm()}
            <div className="center margin--bottom button_container flex flex--space-around margin--top">
               <button
                  onClick={generatePdf}
                  className="btn button__secondary button__rounded small-padding"
               >
                  {pdfType === "welcomeEnvelope" ? t("prints.savePdf") : t("prints.saveAndPrint")}
               </button>
            </div>
         </div>
      </div>
   );
}

export default connect(
   (state) => ({
      session: state.session
   }),
   {}
)(Prints);
